import { useEffect, useState } from "react"
import { Modal } from "antd"
import clsx from "clsx"
import Calendar from "react-calendar"
import { View } from "react-calendar/dist/cjs/shared/types"
import Button from "../button"
import dayjs, { changeLocale } from "../../plugins/dayjs"
import { getLocale, useLanguage } from "@languages/index"

export interface InputDateProps {
  className?: string
  style?: any

  calenderHeader?: () => React.ReactNode
  placeholder?: any
  minDate?: any
  maxDate?: any
  tileDisabled?: any

  defaultValue?: any
  value?: any
  onChange?: any
  isEnabled?: boolean | null

  modalZIndex?: number
}

/**
 * 모바일용 날짜 선택 컴포넌트
 * @param props 
 * @returns 
 */
const InputDate = (props: InputDateProps) => {
  const language = useLanguage()
  const languageTexts = { ...language.common, ...language.component.inputDate }

  // let className = clsx("date-picker", `${props.className}`);
  const [isCalendarVisible, setIsCalendarVisible] = useState(false)
  const [calendarView, setCalenderView] = useState<View>("month")

  const hasValue = (props.value !== null && props.value !== "")
  const isEnabled = (props.isEnabled != null) ? props.isEnabled : true

  changeLocale(dayjs, getLocale())

  return (
    <div className={props.className} style={props.style ? props.style : {}}>
      <div
        onClick={() => {
          if (!isEnabled) {
            return
          }
          setIsCalendarVisible(true)
        }}
        className={clsx([
          "flex flex-row justify-between p-3 user-select-none border",
          isEnabled ? "cursor-pointer" : "bg-[#F4F4F4] cursor-not-allowed",
        ])}
      >
        <div
          className={clsx(
            { "text-sm text-center lg:text-left tracking-tighter": true },
            { "text-gray-400": !hasValue }
          )}
        >
          {props.value
            ? dayjs(props.value).format("YY.MM.DD") +
              (props.value ? ` ${dayjs(props.value).format("ddd")}${getLocale() === "ko" ? "요일" : ""}` : "")
            : props.placeholder}
        </div>
        {/* <div>
          <CalenderIcon size={14} />
        </div> */}
      </div>

      {/* Calendar Modal */}
      <Modal
        className="rounded-antd-modal"
        centered={true}
        open={isCalendarVisible}
        footer={null}
        closable={false}
        zIndex={props.modalZIndex ?? 1010}
        width={400}
      >
        <div className="flex flex-col justify-center align-center p-5 rounded-md bg-white">
          {props.calenderHeader != null && (
            <div className="pb-[8px]">
              {props.calenderHeader()}
            </div>
          )}
          <div className="content flex flex-col">
            <Calendar
              calendarType="gregory"
              className="custom-calendar mt-1"
              tileClassName={({ activeStartDate, date, view }) => {
                // if (view === "month" && date.getDay() === 6) return "!text-blue-700"
                return null
              }}
              formatDay={(locale, date) => {
                return date.getDate().toString()
              }}
              showWeekNumbers={false}
              showNeighboringMonth={true}
              showDoubleView={false}
              showFixedNumberOfWeeks={false}
              tileDisabled={
                props.tileDisabled
                  ? ({ activeStartDate, date, view }) => {
                      return props.tileDisabled(date);
                    }
                  : undefined
              }
              minDate={props.minDate ? props.minDate : null}
              maxDate={props.maxDate ? props.maxDate : null}
              defaultValue={props.defaultValue ? props.defaultValue : undefined}
              value={props.value ? dayjs(props.value).toDate() : undefined}
              onChange={async (value: any) => {
                const date = new Date(value)
                const dateConverted = dayjs(date).format("YYYY-MM-DD")

                if (props.onChange == null) {
                  setTimeout(() => {
                    setIsCalendarVisible(false)
                    setCalenderView("month")
                  }, 300)
                  return
                }

                const result = await props.onChange(dateConverted)
                if (result === false) {
                  return
                }

                setTimeout(() => {
                  setIsCalendarVisible(false)
                  setCalenderView("month")
                }, 300)
              }}
              view={calendarView}
              onViewChange={({ action, activeStartDate, value, view }) => {
                setCalenderView(view)
              }}
            />
          </div>
          <div className="buttons flex flex-row mt-4 gap-1.5">
            <Button
              className={"min-w-[10rem] py-3 flex justify-center"}
              style={{ flex: "1 1 60%" }}
              textClassName={"text text-sm tracking-tighter text-base text-center"}
              textColor={"white"}
              buttonColor={"#555"}
              text={languageTexts.release}
              onClick={() => {
                if (props.onChange != null) props.onChange("")
                setIsCalendarVisible(false)
                setCalenderView("month")
              }}
            />
            <Button
              className={"min-w-[2rem] py-3 flex justify-center"}
              style={{ flex: "1 1 40%" }}
              textClassName={"text text-sm tracking-tighter text-base text-center"}
              textColor={"white"}
              buttonColor={"black"}
              text={languageTexts.close}
              onClick={() => {
                setIsCalendarVisible(false)
                setCalenderView("month")
              }}
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default InputDate
